import React from 'react'
import demoimage from '../../assets/BugBountyImages/demotoolimage.png'

const ExerciseComponent = ({item,index}) => {
  return (
      <>

<div class={"col-lg-3 col-6  p-2"+" fade-in-bottom "+"delay"+index+"s"}>
   
    <a href={item.attack_url} class="">
        <div class="shadow position-relative  rounded border bugbountycontent">
            <img src={item.image_url} class="img-responsive rounded-bottom-0 w-100 rounded"></img>
            

            <div class="p-2 text-dark text-center text-decoration-none">
                <h4 class="text-light truncate truncate2 sm-16">{item.title}</h4>
                <p class="truncate truncate-3 truncate3 sm-12">{item.description}
                </p>
                <div class="d-flex justify-content-center mt-2 mb-2 ">
                <button class="btn btn-primary sm-10  truncate truncate1 rounded btn-sm rounded-pill pb-2">Let's Inject Some Code</button>

                </div>
            </div>
        </div>
    </a>

   
</div>


   
    </>
  )
}

export default ExerciseComponent
